import clsx from "clsx";
import React from "react";
import { Width, widthClass } from "../Layout";
import css from "./progress.module.scss";

interface ProgressBarProps
{
    caption: string;
    captionWidth?: Width;
    progress: number;
}

export const ProgressBar = ({ caption, captionWidth, progress }: ProgressBarProps): React.FunctionComponentElement<ProgressBarProps> => 
{
    return (
        <div className={css["progress-bar"]}>
            <span className={clsx(css["caption"], widthClass(captionWidth))}>{caption}</span>
            <span className={css["scale"]}>
                {
                    new Array(10).fill(null).map((_, i) => <span key={i}>·</span>)
                }
                <span className={css["progress"]} style={{ maxWidth: `${progress}%` }} />
            </span>
        </div>
    );
};